import { useSyncExternalStore } from 'react';

type Theme = 'light' | 'dark';

const listeners = new Set<() => void>();

let current: Theme =
  typeof document !== 'undefined' && document.documentElement.classList.contains('dark')
    ? 'dark'
    : 'light';

const apply = (theme: Theme) => {
  current = theme;
  document.documentElement.classList.toggle('dark', theme === 'dark');
  try {
    localStorage.setItem('theme', theme);
  } catch {
    /* ignore storage errors */
  }
  listeners.forEach((l) => l());
};

export const toggleTheme = () => apply(current === 'dark' ? 'light' : 'dark');

const subscribe = (cb: () => void) => {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
};

/** Theme state synced across all consumers via an external store. */
export const useTheme = () => {
  const theme = useSyncExternalStore(
    subscribe,
    () => current,
    () => 'light' as Theme
  );
  return { theme, toggle: toggleTheme };
};
